// extracted by mini-css-extract-plugin
var _1 = "CardAdd_wrapper__9EuBI";
var _2 = "CardAdd_wrapperClosed__aNshS";
export { _1 as "wrapper", _2 as "wrapperClosed" }
